export default function() {
  return {
    plots: [],
    plotItems: [],
    plotSearchResults: [],
    drawings: [],
    drawingCategories: []
  }
}
